import { apiService } from "./api.js";

const BASE_URL_TRACK = process.env.REACT_APP_API_TRACK;
const BASE_URL_TRACK_AUTH = process.env.REACT_APP_API_TRACK_AUTH;
const MIDDLEWARE_CLIENT = process.env.REACT_APP_CLIENT_ID;
const MIDDLEWARE_SECRET = process.env.REACT_APP_SECRET;
const UAT_MIDDLEWARE_SECRET = process.env.REACT_APP_UAT_SECRET;
const REACT_APP_API_MAIN = process.env.REACT_APP_API_MAIN;
const REACT_APP_API_CUSTOMER_APP = process.env.REACT_APP_API_CUSTOMER_APP;

const apiCall = {
  allbranchesApi: (header = undefined) => {
    return new apiService().get("Locations/GetAllBranches", header);
  },
  // branchesbycityApi: (city, header = undefined) => { return new apiService().get(`Locations/GetBranchesByCityName?City=${city}`, header) },
  // citiesApi: (header = undefined) => { return new apiService().get('Locations/GetUniqueCities', header) },
  middlewareAuthToken: (header = undefined) => {
    return new apiService().bridgeApiAUTH(
      `/auth?ClientID=${MIDDLEWARE_CLIENT}&ClientSecret=${MIDDLEWARE_SECRET}`
    );
  },
  // trackApiNew: (params, header = undefined) => {
  //   return new apiService().bridgeApi(
  //     `/Tracking/GetTrackingDetails?consignee=${params}`,
  //     header
  //   );
  // },

  uatmiddlewareAuthToken: (header = undefined) => {
    return new apiService().emailbridgeApiAUTH(
      `/auth?ClientID=${MIDDLEWARE_CLIENT}&ClientSecret=${UAT_MIDDLEWARE_SECRET}`
    );
  },

  // Saif's code below
  sendEmail: (body, header = undefined) => {
    return new apiService().bridgeApiEmail(`sendemail`, header, body);
  },
  insertPickup: (body, header = undefined) => {
    return new apiService().bridgeApiPickup(`insertpickup`, header, body);
  },
  getTarif: (body, header = undefined) => {
    return new apiService().bridgeApiTarif(`gettarif`, header, body);
  },
  getCity: (header = undefined) => {
    return new apiService().bridgeApiCities(`getcities`, header);
  },
  getServices: (header = undefined) => {
    return new apiService().bridgeApiServices(`getservices`, header);
  },

  /*getBranchesByCity: (params, header = undefined) => {
        return new apiService().basicBridgeApi(
            `/cls/api/Setup/GetExpressCenters?city=${params}`,
            header
        );
    },
*/

  //Usama Code

  getBranchesByCity: (header = undefined) => {
    return new apiService().basicBridgeApi(`getbranchesbycity`, header);
  },

  getAreaCode: (header = undefined) => new apiService().bridgeApiArea(header),
  // getAreaCode: (header = undefined) => {
  //   return new apiService().bridgeApiArea(`getareacode`, header);
  // },

  //farhan code

  trackApiNew: (header = undefined) => {
    return new apiService().bridgeApi(`trackapinew`, header);
  },

  /*getServices: (header = undefined) => {
            return new apiService().basicBridgeApi(
                "/customerapp/api/setup/getServices",
                header
            );
    },*/

  //LIve

  // trackApiNew: (params, header = undefined) => { return new apiService().bridgeApi(`consignee=${params}`, header) },
  // sendEmail: (body, header = undefined) => { return new apiService().bridgeApiEmail(header, body) },
  // inserPickup: (body, header = undefined) => { return new apiService().bridgeApiPickup( header, body) },
  // getTarif: (body, header = undefined) => { return new apiService().bridgeApiTarif( header, body) },
  // getCity: (header = undefined) => new apiService().bridgeCitiesApi( header),
  // getBranchesByCity: (params, header = undefined) => new apiService().bridgeBranchesCityApi(`city${params}`, header),

  //LIve
};

export default apiCall;
